import { useQuery } from "@tanstack/react-query";
import type { CoreSettings } from "@repo/types/common";
import { settingKeys } from "@repo/types/queries";
import type { SettingDTO } from "@repo/types/dtos";
import { useApiAccess } from "@repo/hooks/contexts";

export function useSettings() {
  const { apiClient } = useApiAccess();

  return useQuery<CoreSettings>({
    queryKey: settingKeys.all,
    queryFn: async () => {
      const response = await apiClient.get<SettingDTO[]>("/setting/get");
      const settings: SettingDTO[] = response.data;

      const coreSettings: CoreSettings = {
        SiteURL: settings.find((s) => s.Key === "Site.URL")?.Value || "",
        AzureStorageAccountName:
          settings.find((s) => s.Key === "Site.Azure.Storage.AccountName")
            ?.Value || "",
        AzureStorageContainerName:
          settings.find((s) => s.Key === "Site.Azure.Storage.ContainerName")
            ?.Value || "",
        AzureStorageFolderName:
          settings.find((s) => s.Key === "Site.Azure.Storage.FolderName")
            ?.Value || "",
        AzureStorageTenantFolderName:
          settings.find((s) => s.Key === "Site.Azure.Storage.TenantFolderName")
            ?.Value || "",
      };
      return coreSettings;
    },
  });
}
